angular.module('agreements')
    .component('agreementList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/agreements/list-agreement.html',
        controller: function ($scope, $state, $stateParams, Agreement, AgreementService, AgreementConst) {
            this.AgreementService = AgreementService
            this.types = AgreementService.getTypes('AGREEMENT')

            this.reset = () => this.filters = {}
            $scope.$on(AgreementConst.eventUpdate, () => $state.reload())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
